import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';

export default function SidebarNewBadge({ colors, label, subtle = false }) {
  return (
    <View
      style={{
        backgroundColor: subtle ? colors.solid_color_tertiary : colors.accent_color_primary,
        paddingHorizontal: subtle ? 6 : 5,
        paddingVertical: 1,
        borderRadius: subtle ? 6 : 4,
        marginRight: 2,
        alignSelf: 'center',
      }}
    >
      <Text
        weight={subtle ? 'medium' : 'extraBold'}
        style={{
          color: subtle ? colors.text_color_secondary : colors.accent_text_color,
          fontSize: subtle ? 10 : 9,
          letterSpacing: subtle ? 0 : 0.6,
          lineHeight: subtle ? 14 : 12,
        }}
      >
        {label}
      </Text>
    </View>
  );
}
